<template>
  <div class="pageContent">
    <div class="top-form">
      <el-form
      ref="form"
      inline
      :model="form"
    >
      <el-form-item label="状态" prop="pay_status">
        <el-select
          size="small"
          v-model="form.status"
          placeholder="请选择状态"
          @change="onSearch"
        >
        <el-option label="全部" :value="null"></el-option>
          <el-option label="未生效" :value="0"></el-option>
          <el-option label="已生效" :value="1"></el-option>
          <el-option label="已失效" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="卡名称" prop="card_name">
        <el-input
          size="small"
          placeholder="名称"
          v-model="form.card_name"
          clearable
          @clear="close('name')"
        ></el-input>
      </el-form-item>
      <el-form-item label="平台卡号" prop="order_sn">
        <el-input
          size="small"
          placeholder="平台卡号"
          v-model="form.card_number"
          clearable
          @clear="close('card_number')"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="手机号" prop="mobile">
        <el-input
          size="small"
          style="width: 150px"
          placeholder="购买用户手机号"
          v-model="form.mobile"
          clearable
          @clear="close('mobile')"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="onSearch"
          >搜索</el-button
        >
        <el-button size="small" @click="reset">重置</el-button>
      </el-form-item>
      </el-form>
    </div>
    <div class="table_box">
      <el-table  :data="tableData" style="width: 100%;margin: 20px auto;" border>
        <el-table-column prop="card_number" align="center" label="卡号" > </el-table-column>
        <el-table-column prop="card_name" align="center" label="卡名"> </el-table-column>
        <el-table-column prop="card_type" align="center" label="卡类型" >
          <template slot-scope="scope">
            <div>{{card_type[scope.row.card_type]}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="card_type" align="center" label="总额度" >
          <template slot-scope="scope">
            <div v-if="scope.row.card_type==1">{{scope.row.card_amount}}元</div>
            <div v-else-if="scope.row.card_type==2">{{scope.row.card_num}}次</div>
            <div v-else>{{scope.row.show_card_duration}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="card_type" label="剩余额度" >
          <template slot-scope="scope">
            <div v-if="scope.row.card_type==1">{{scope.row.remain_card_amount}}元</div>
            <div v-else-if="scope.row.card_type==2">{{scope.row.remain_card_num}}次</div>
            <div v-else>
              <div v-if="scope.row.card_type==3">到期时间</div>
              <div>{{scope.row.show_card_expire}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" align="center" label="用户"></el-table-column>
        <el-table-column prop="pay_status" align="center" label="状态" >
          <template slot-scope="scope">
            <el-tag :type="items[scope.row.status].type" effect="dark">
              {{ items[scope.row.status].name }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope" v-if="scope.row.status==1">
            <el-button type="text" @click="Disable(scope.row)">失效</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :hide-on-single-page="total_num <= 10"
        style="width: 95%;margin: 20px auto; "
        layout="prev, pager, next"
        :total="total_num"
        @current-change="current_page"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { platformcard_card_userlist,disable_card_data_user } from "@/api/platform_card";
import { mapGetters } from "vuex";
import paywayList from "@/utils/payment_code";
import time from "@/utils/time";
import Template from "../../set/smsConfig/template";
import {employeeList} from '@/api/employee'

export default {
  components: { Template },
  computed: {
    ...mapGetters(["app_id"])
  },
  data() {
    return {
      form: {
        pay_status: null
      },
      statData:{},
      emplist:[],
      time:[],
      card_type: ["", "金额", "次数", "时间"],
      paywayList: paywayList,
      source_index: [
        "wx",
        "wxapp",
        "h5",
        "ali",
        "aliapp",
        "pc",
        "hand",
        "pos",
        "ruyi"
      ],
      source_name: [
        "微信",
        "微信小程序",
        "h5",
        "支付宝",
        "支付宝小程序",
        "后台",
        "手持设备",
        "终端机",
        "如意"
      ],
      items: [
        { type: "info", name: "未生效" },
        { type: "success", name: "已生效" },
        { type: "danger", name: "已失效" },
      ],
      tableData: [],
      page: 1,
      total_num: 0
    };
  },
  mounted() {
    this.get_tableData();
  },
  methods: {
    async Disable(row){
      const res = await disable_card_data_user({
        app_id:this.app_id,
        id:row.id
      })
      if(res.code == 200){
        this.get_tableData(this.form)
      }
    },
    //搜索
    onSearch() {
      this.get_tableData(this.form);
    },
    //清空input
    close(val){
      switch (val){
        case 'name':
          this.form.card_name = undefined
          break;
        case 'card_number':
          this.form.card_number = undefined
          break;
        case 'mobile':
          this.form.mobile = undefined
          break;
      }
      this.get_tableData(this.form)
    },
    
    //重置
    reset() {
      Object.keys(this.form).forEach(key => {
        delete this.form[key];
      });
      this.get_tableData();
    },
    async get_tableData(data) {
      try {
        let data_val = {
          app_id: this.app_id,
          page: this.page,
          ...data
        };
        const res = await platformcard_card_userlist(data_val);
        this.tableData = res.data.result;
        console.log(this.paywayList);
        this.tableData.forEach((item, i) => {
          if(item.card_duration){
            item.show_card_duration = time.secondsFormat(item.card_duration)
          }
          if(item.card_expire){
            item.show_card_expire = time.setTime(item.card_expire)
          }
        });
        console.log("2w22", this.tableData);
        this.total_num = res.data.total_num;
        // this.getdatas(data_val)
      } catch (e) {
        console.log(e);
      }
    },
    timer(originVal) {
      const dt = new Date(originVal * 1000);
      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "").padStart(2, "0");
      const d = (dt.getDate() + "").padStart(2, "0");
      const hh = (dt.getHours() + "").padStart(2, "0");
      const mm = (dt.getMinutes() + "").padStart(2, "0");
      const ss = (dt.getSeconds() + "").padStart(2, "0");
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },
    current_page(val) {
      this.page = val;
      this.get_tableData();
    },
    info(row) {
      this.$router.push({
        path: "/apply/newVip/13/card/activityCard/set_card",
        query: {
          id: row.id
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.pageContent {
  background-color: #f1f2f6;
  border: 20px solid #f1f2f6;
  // padding: 0 20px 10px 20px;
  height: 100%;
  overflow: auto;
  .options {
    line-height: 79px;
  }
  .table_box {
    margin-bottom: 20px;
    padding: 10px;
    background-color: #fff;
  }
  .form_input {
    width: 240px;
  }
  .top-form{
    padding: 20px;
    background-color: #fff;
  }
}
.stat_box {
    // margin-top: 20px;
    display: flex;
    padding: 8px 0;
    justify-content: space-between;
    .stat_item:first-child {
      margin: 0;
    }
    .stat_item {
      width: 9%;
      background: #fff;
      height: 100px;
    }
    .stat_item2 {
      width: 45.5%;
      background: #fff;
      height: 100px;
    }
    .stat_item3 {
      width: 45%;
      background: #fff;
      height: 100px;
    }
    .stat_item_title {
      height: 29px;
      line-height: 29px;
      padding-left: 10px;
      border-bottom: 1px solid #f5f5f5;
    }
    .stat_item_value {
      width: 100%;
      height: 60%;
      padding: 0px 10px;
      // padding-top: 8px;
      font-size: 21px;
      // line-height: 21px;
      color: #666;
      display: flex;
      align-items: center;
      // justify-content: center;
      span {
        font-size: 14px;
      }
    }
    .stat_item_value2 {
      text-align: center;
      line-height: 24px;
      color: #666;
      display: flex;
      .item_value_part {
        flex: 5;
        padding-top: 6px;
        .part_name {
          height: 30px;
          line-height: 30px;
        }
        .part_value {
          font-size: 22px;
          span {
            font-size: 14px;
          }
        }
      }
      .part_line {
        margin-top: 18px;
        height: 34px;
        border-right: 1px solid #ddd;
      }
    }
    .stat_item_value3 {
      color: #666;
      display: flex;
      .item_value_part {
        padding-left: 10px;
        flex: 1;
        padding-top: 7px;
        .part_value {
          font-size: 20px;
          line-height: 26px;
          span {
            font-size: 13px;
          }
        }
      }
      .part_line {
        margin-top: 18px;
        height: 34px;
        border-right: 1px solid #ddd;
      }
    }
    .stat_item_value4 {
      color: #666;
      display: flex;
      text-align: center;
      .item_value_part {
        flex: 1;
        padding-top: 12px;
        .part_title4 {
          font-size: 13px;
          margin-bottom: 5px;
        }
        .part_value {
          font-size: 20px;
          line-height: 26px;
          span {
            font-size: 13px;
          }
        }
      }
      .part_line {
        margin-top: 18px;
        height: 34px;
        border-right: 1px solid #ddd;
      }
    }
  }
</style>
